import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c1sf0978";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const paragraphCss = "prvpd4q";
const Paragraph = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(paragraphCss, props.className)} />;
});
export default () => <Container>
    <Paragraph>
      <strong>
        {I18n.t('publisher.enforcement.subscription_needs_upgrade')}
      </strong>
    </Paragraph>
    <div>
      {I18n.t('publisher.enforcement.contact_calendly_admin')}
    </div>
  </Container>;

require("./passive_enforcement.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./passive_enforcement.js");